/// <amd-module name="Wit/WorkItemDataManager/Sources/QueryDataProviderSource" />
import { localeIgnoreCaseComparer } from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { IFieldEntry } from "Wit/Common/Generated/Contracts";
import { IFieldProjectData, ILinkTypes, IWorkItemData, IWorkItemDataSource, IWorkItemTypeData } from "Wit/WorkItemDataManager/Contracts";

/**
 * Data returned by the data provider for the query hub
 */
interface IQueryDataProviderPayload {
    projectFieldData?: IFieldProjectData;
}

const QueryDataProviderId = "ms.vss-work-web.query-data-provider";

export class QueryDataProviderSource implements IWorkItemDataSource {
    private pageContext: IVssPageContext;

    constructor(pageContext: IVssPageContext) {
        this.pageContext = pageContext;
    }

    public beginGetWorkItemData(
        ids: number[],
        isDeleted?: boolean,
        includeInRecentActivity?: boolean,
        includeHistory?: boolean
    ): Promise<IWorkItemData[] | null> {
        return Promise.resolve(null);
    }

    public beginGetWorkItemTypeData(projectId: string, typeNames: string[]): Promise<IWorkItemTypeData[] | null> {
        return Promise.resolve(null);
    }

    public beginGetLinkTypes(): Promise<ILinkTypes | null> {
        return Promise.resolve(null);
    }

    public beginGetConstantSets(ids: string[]): Promise<{ [key: string]: string[] } | null> {
        return Promise.resolve(null);
    }

    public beginGetFields(): Promise<IFieldEntry[] | null> {
        return Promise.resolve(null);
    }

    public beginGetFieldProjectData(projectId: string): Promise<IFieldProjectData | null> {
        const pageData = this._getDataProviderData();
        const projectFieldData = pageData && pageData.projectFieldData;
        if (projectFieldData) {
            const hasProject = projectFieldData.projects.some(project => {
                return localeIgnoreCaseComparer(project.guid, projectId) === 0 || localeIgnoreCaseComparer(project.name, projectId) === 0;
            });

            if (hasProject) {
                return Promise.resolve(projectFieldData);
            }
        }

        return Promise.resolve(null);
    }

    private _getDataProviderData(): IQueryDataProviderPayload | undefined {
        const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
        return contributionService.getData<IQueryDataProviderPayload>(QueryDataProviderId);
    }
}
